// Foundations
import { Component, OnInit } from '@angular/core';

import { AppVersionInfoService } from 'src/app/services/utils/app-version-utils.service';

@Component({
  selector: 'app-privacy-policy-footer',
  templateUrl: './privacy-policy-footer.component.html',
  styleUrls: ['./privacy-policy-footer.component.scss'],
})
export class PrivacyPolicyFooterComponent implements OnInit {
  copyrightYear: number;
  versionInfo: string;

  constructor(private _appVersionInfoService: AppVersionInfoService) {}

  ngOnInit(): void {
    this.copyrightYear = new Date().getFullYear();

    // Get "version info"
    this.versionInfo = this._appVersionInfoService.getVersionInfo();
  }
}
